import { render, staticRenderFns } from "./WordReplacements.vue?vue&type=template&id=d8667a66&scoped=true"
import script from "./WordReplacements.vue?vue&type=script&lang=js"
export * from "./WordReplacements.vue?vue&type=script&lang=js"
import style0 from "./WordReplacements.vue?vue&type=style&index=0&id=d8667a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8667a66",
  null
  
)

export default component.exports